var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#272B30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17C6 15.3431 4.65685 14 3 14H1C0.447715 14 0 14.4477 0 15C0 15.5523 0.447715 16 1 16H3C3.55228 16 4 16.4477 4 17V19C4 19.5523 4.44772 20 5 20C5.55228 20 6 19.5523 6 19V17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3C14 4.65685 15.3431 6 17 6L19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4L17 4C16.4477 4 16 3.55228 16 3V1C16 0.447715 15.5523 0 15 0C14.4477 0 14 0.447715 14 1V3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14C15.3431 14 14 15.3431 14 17V19C14 19.5523 14.4477 20 15 20C15.5523 20 16 19.5523 16 19V17C16 16.4477 16.4477 16 17 16H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C4.65685 6 6 4.65685 6 3V1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1V3C4 3.55228 3.55228 4 3 4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyZoomOut);
export default __webpack_public_path__ + "static/media/copyZoomOut.c2217232389b157a7f28e807fe7c1718.svg";
export { ForwardRef as ReactComponent };